import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export interface Sucursal {
    IdSucursal: number;
}

type Entity = Sucursal;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
 * Valida un EnSucursal
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdSucursal: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Selecciona una sucursal
*/
export class EnSucursalEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);
        
        const Sucursal = getField(selectores.Sucursal);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Asignar a sucursal"
            >

                {kea.autogrid(6, [
                    <Sucursal field="IdSucursal" />
                ])}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/edit/ensucursal/modal.tsx